import { render, staticRenderFns } from "./imgUpLoader.vue?vue&type=template&id=08c6ed75&scoped=true&"
import script from "./imgUpLoader.vue?vue&type=script&lang=js&"
export * from "./imgUpLoader.vue?vue&type=script&lang=js&"
import style0 from "./imgUpLoader.vue?vue&type=style&index=0&id=08c6ed75&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c6ed75",
  null
  
)

export default component.exports